<template>
  <div class="aside-fa">
    <!--   -->
    <div>
      <el-menu
        background-color="#fff"
        text-color="#808080"
        active-text-color="#409EFF"
        unique-opened
        :default-active="editableTabsValue"
        :collapse="isCollapse"
        :collapse-transition="false"
        router
      >
        <el-submenu
          v-for="item in menu_list"
          :v-show="item.show"
          :key="item.index"
          :index="item.index"
        >
          <template slot="title">
            <div>
              <i :class="item.icon_class" style="color: #409eff;"></i>
              <span class="one">{{ item.total_name }}</span>
            </div>
          </template>
          <el-menu-item
            v-for="(citem, index) in item.children"
            :key="index"
            :index="citem.index"
            @click="saveNavState(citem.index, citem.name)"
          >
            <template slot="title">
              <i :class="citem.icon_class"></i>
              <span>{{ citem.name }}</span>
            </template>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <div
      v-if="!isltr"
      class="collapse-menu"
      :class="unclick ? 'toggle-button button-unclick' : 'toggle-button'"
      @click="toggleCollapse"
    >
      <i
        class="el-icon-upload2 left-icon"
        :class="isCollapse ? 'left-icon-clicked' : 'left-icon-click'"
      ></i>
      <span v-if="!isCollapse" style="margin-left:10px">收起菜单</span>
    </div>
    <div
      v-else
      class="collapse-menu toggle-button"
      @click="hideDraw"
    >
      <i
        class="el-icon-upload2 left-icon left-icon-click"
      ></i>
      <!-- :class="isCollapse ? 'left-icon-clicked' : ''" -->
      <span v-if="!isCollapse" style="margin-left:10px">收起菜单</span>
    </div>
  </div>
</template>

<script scoped>
import { mapState, mapMutations } from "vuex";
export default {
  name: "homeaside",
  props: ["list", "isltr"],

  data() {
    return {
      activePath: "",
      isCollapse: false,
      // 控制侧边栏隐藏显示按钮是否可点击
      unclick: false,
      menu_list: [],
      resolution: "",
      aside_height: ""
      /* screen_w: window.screen.availWidth,
      body_w: document.body.clientWidth */
    };
  },
  computed: {
    editableTabsValue() {
      return this.$store.state.home.editableTabsValue;
    },
    availWH() {
      return this.$store.state.resolution.availWH;
    },
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (this.isltr) {
          this.isCollapse = false;
          this.unclick = false;
        } else {
          if (this.availWH.availWidth - newinner.innerWidth < 300) {
            this.isCollapse = false;
            this.unclick = false;
          } else {
            this.isCollapse = true;
            this.unclick = true;
          }
          this.$emit("Collapse", this.isCollapse);
        }
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    this.resolution = window.screen.height * window.screen.width;
  },
  mounted() {
    this.menu_list = this.list;
    this.body_w = document.documentElement.clientWidth;

    this.$emit("Collapse", this.isCollapse);
  },
  methods: {
    ...mapMutations("home", ["ADDTABS"]),
    hideDraw(){
      this.$emit("hideDraw",false);
    },
    toggleCollapse() {
      // console.log(this.unclick)
      if (this.unclick) {
      } else {
        this.isCollapse = !this.isCollapse;
        this.$emit("Collapse", this.isCollapse);
      }
    },
    // 刷新之后也可以保持高亮状态
    saveNavState(activePath, title) {
      if (this.$store.state.home.menuTabs.length >= 10) {
        this.warnMessage("标签页最多打开10个！");
        return;
      }
      this.ADDTABS({
        activePath,
        title
      });
      this.hideDraw();
    }
  }
};
</script>
<style lang="less">
.aside-fa {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  // background-color: rgb(233, 118, 118);
}
.el-container {
  height: 100%;
}
.left-menu {
  height: 40px;
  text-align: center;
  line-height: 3;
  background-color: #e3e3e3;
}
.el-menu {
  border-right: none;
}
.toggle-button {
  position: relative;
  bottom: 0px;
  user-select: none;
  font-size: 10px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-right: none;
  border-left: none;
  background-color: #fff;
}
.button-unclick {
  background-color: @disabled-color;
  cursor: not-allowed;
}
.el-submenu {
  font-size: 24px;
  /* border-bottom: 1px solid rgb(151, 150, 150); */
}

.el-icon-vip {
  display: inline-block;
  width: 15px;
  height: 15px;
  font-style: oblique;
  font-size: 12px !important;
  text-align: center;
  border-radius: 50% 50%;
  border: 1px solid #409eff;
  background-color: #409eff;
  color: #fff;
}

.el-icon-vip::before {
  content: "vip";
  color: #fff;
}

.el-icon-all-vip {
  display: inline-block;
  // width: 10px;
  // height: 10px;
  font-style: oblique;
  font-size: 12px !important;
  text-align: center;
  // border-radius: 50% 50%;
  // border: 1px solid #409eff;
  // background-color: #409eff;
  color: #fff;

}
.el-icon-all-vip::before {
  content: "VIP";
  font-weight: 700;
  // color: #fff;
}





.el-icon-vip-son {
  display: inline-block;
  width: 15px;
  height: 15px;
  font-style: oblique;
  font-size: 12px !important;
  text-align: center;
  border-radius: 50% 50%;
}
.el-icon-vip-son::before {
  content: "vip";
}

.icon-style-item {
  display: inline-block;
  color: #409eff;
  vertical-align: middle;
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
}
.collapse-menu {
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  color: #808080;
  .left-icon {
    font-size: 20px;
    //
  }
  .left-icon-click {
    transform: rotate(-90deg);
    margin-bottom: 2px;
  }
  .left-icon-clicked {
    transform: rotate(90deg);
  }
}
</style>
